import { render } from "./GradientProgressBar.vue?vue&type=template&id=7a529e5d&scoped=true"
import script from "./GradientProgressBar.vue?vue&type=script&lang=js"
export * from "./GradientProgressBar.vue?vue&type=script&lang=js"

import "./GradientProgressBar.vue?vue&type=style&index=0&id=7a529e5d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a529e5d"]])

export default __exports__